import { render, staticRenderFns } from "./PromosInfo.vue?vue&type=template&id=51001f4a"
import script from "./PromosInfo.vue?vue&type=script&lang=js"
export * from "./PromosInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports